import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import Service from "./pages/Service";
import TestPage from "./pages/TestPage";

import "./App.css";

function App() {
  return (
    <BrowserRouter>

      <Navbar />

      <main>

        <Routes>

          <Route path="/" element={<HomePage />} />

          <Route path="/about" element={<AboutPage />} />

          <Route path="/contact" element={<ContactPage />} />

          <Route path="/service" element={<Service />} />

          <Route path="/tests/:slug" element={<TestPage />} />

        </Routes>

      </main>

      <FloatingWhatsApp />

      <Footer />

    </BrowserRouter>
  );
}

export default App;